import { LOGIN, SET_USER, LOGOUT, SET_PARAMS } from "../actionTypes"

const initial = { 
    user: null,
    params: {},
    loggedIn: sessionStorage.getItem('token') ? true : false,
    token: sessionStorage.getItem('token')
}

const application = (state = initial, action) => {
    switch (action.type) {
        // Auth
        case LOGIN:
            sessionStorage.setItem('token', action.token)

            return {
                ...state,
                loggedIn: true,
                token: action.token
            }

        case SET_USER:
            return {
                ...state,
                user: action.user
            }

        case LOGOUT:
            sessionStorage.removeItem('token')

            return {
                ...state,
                loggedIn: false,
                token: null,
                user: null
            }

        case SET_PARAMS:
            return {
                params: action.params
            }

        default:
            return state
    }
}

export default application